export const VIEW_CONTRACT_DETAILS_TOGGLE = "VIEW_CONTRACT_DETAILS_TOGGLE";
export const SET_CONTRACT_DETAILS_TYPE = "SET_CONTRACT_DETAILS_TYPE";
export const RESET_CONTRACT_DETAILS = "RESET_CONTRACT_DETAILS";
export const SET_REQUEST_CONTRACT_DETAILS = "SET_REQUEST_CONTRACT_DETAILS";
export const SET_DISABLE_NEXT = "SET_DISABLE_NEXT";
export const SET_CONTACT_FORM_DETAILS_ERROR = "SET_CONTACT_FORM_DETAILS_ERROR";
export const SET_CASE_CREATION_SUCCESS = "SET_CASE_CREATION_SUCCESS";
export const GET_ACTIVE_CANCELLATION_CASE_LIST = "GET_ACTIVE_CANCELLATION_CASE_LIST";
export const ACTIVE_CANCELLATION_CASE_LIST = "ACTIVE_CANCELLATION_CASE_LIST";
export const IS_ACTIVE_CANCELLATION_ERROR = "IS_ACTIVE_CANCELLATION_ERROR";
export const IS_ACTIVE_CANCELLATION_SUCCESS = "IS_ACTIVE_CANCELLATION_SUCCESS";
export const CANCELLATION_CASE_DETAILS_LOADER = "CANCELLATION_CASE_DETAILS_LOADER";
export const SET_DUPLICATE_REQUEST = "SET_DUPLICATE_REQUEST";
export const RESET_CANCELLATION_CASE_DETAILS = "RESET_CANCELLATION_CASE_DETAILS";

export function toggleViewContractDetails(value) {
  return {
    type: VIEW_CONTRACT_DETAILS_TOGGLE,
    value,
  };
}

export function setRequestContractDetails(field, value) {
  return {
    type: SET_REQUEST_CONTRACT_DETAILS,
    field,
    value,
  };
}

export function setDisableNext(value) {
  return {
    type: SET_DISABLE_NEXT,
    value,
  };
}

export function setContractDetailsType(value) {
  return {
    type: SET_CONTRACT_DETAILS_TYPE,
    value,
  };
}

export function setContractFormDetailsError(field, value) {
  return {
    type: SET_CONTACT_FORM_DETAILS_ERROR,
    field,
    value,
  };
}

export function resetContractDetails() {
  return {
    type: RESET_CONTRACT_DETAILS,
  };
}

export function setCaseCreationSuccess(value) {
  return {
    type: SET_CASE_CREATION_SUCCESS,
    value,
  };
}

export function getActiveCancellationCasesList() {
  return {
    type: GET_ACTIVE_CANCELLATION_CASE_LIST,
  };
}

export function activeCancellationCaseList(value) {
  return {
    type: ACTIVE_CANCELLATION_CASE_LIST,
    value,
  };
}

export function isActiveCancellationError(value) {
  return {
    type: IS_ACTIVE_CANCELLATION_ERROR,
    value,
  };
}

export function isActiveCancellationSuccess(value) {
  return {
    type: IS_ACTIVE_CANCELLATION_SUCCESS,
    value,
  };
}

export function isLoader(value) {
  return {
    type: CANCELLATION_CASE_DETAILS_LOADER,
    value,
  };
}

export function isDuplicateRequest(value) {
  return {
    type: SET_DUPLICATE_REQUEST,
    value,
  };
}

export function resetCancellationCaseDetails() {
  return {
    type: RESET_CANCELLATION_CASE_DETAILS,
  };
}
